export const API_WEB_URLS = {
// BASE: "https://testapi.rsevakendra.in/api/V1/",
  // BASE: "https://687c-103-211-43-215.ngrok-free.app/api/V1/",
  // BASE1: "https://c667-103-211-43-215.ngrok-free.app/api/V1/",
  // BASE1: "https://localhost:44362/api/V1/",
  //IMAGEBASE: "https://localhost:44362`/",
  //BASE: "http://26.8.28.180:7037/api/V1/",
 BASE: "https://busbuddy-gwcjb6frhhcshddm.canadacentral-01.azurewebsites.net/api/V1/",
// BASE: "https://lk.shinewellsofttech.co.in/api/V1/",
 IMAGEBASE: "https://pro.rsevakendra.in/",
  LOGIN: "Authentication/Login",
  //
  MASTER: "Masters",
  MEMBEREDITDATA : "Masters/0/token/MemberEdit/Id",
  BALANCEEDITDATA : "Masters/0/token/BalanceEdit/Id",
  SMSAPIEDITADD: "Masters/0/token/SMSAPIEdit/Id",
  CUSTOMER: "CustomerMaster",
  MEMBERMASTER: "AddMemberMaster",

  RECHARGEAPI: "RechargeAPI",

  RECHARGEOPERATOR: "RechargeOperator",

  BALANCEADD: "BalanceAdd",
  PLANMASTERL: "PlanMasterL",
  USERMASTER: "AddUserMaster",
  SENDERMASTER: "SenderMaster",
  BENEFICIARYMASTER: "BeneficiaryMaster",
  VERIFY: "Verify",
  SMSAPIADD: "SMSAPI",
  BANKADD: "BankMaster",
  COMPANY : "CompanyMaster",
  RemitterNoCheck : "RemitterNoCheck",
  AgentRegistration : "AgentRegistration",
  SHIFT : "ShiftMaster",
  RAWDATA : "InsertRawData",
  GLOBALOPTIONS : "UpdateGlobalOptions",
  UPDATEMEMBERSERVICE : "UpdateServiceMember"

};
